import React , {useEffect} from 'react'
import * as ml5 from 'ml5'

//global.ml5 = ml5;
/* useEffect(() => {
 // ml5 = require('ml5')
}, []) */

console.log('ml5 version:', ml5.version);
  // Initialize the Image Classifier method with MobileNet
  //const classifier = ml5.imageClassifier('MobileNet', modelLoaded);
  // When the model is loaded
  function modelLoaded() {
    console.log('Model Loaded!');
  }

function Testpage() {
  return (
    <div>
      This is test Machine Learning page
    </div>
  )
}

export default Testpage
